module.exports = __webpack_public_path__ + "img/8f87faf7bd78b15c096b0b9c023ab33f.jpg";